export default __webpack_public_path__ + "static/icon-23-2-c4f6e5117fc0c1f786bc03a996add46b.png";